import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { FILTERS_ENDPOINT, getBaseUrl } from '../../constants';

export class Filters {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Filters(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = FILTERS_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAllFilteredData(req) {
    const queryString = queryBuilder(req);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }
}
export const createFilters = () => Filters.getInstance();
